import React, { Suspense, useEffect, useState } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { FilterProvider } from './components/FilterContext';
import { AuthProvider } from './components/services/AuthContext';
import { SEOProvider } from './components/SEOContext'; // Import the SEOProvider
import RoutesConfig from './RoutesConfig.jsx';

import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';

console.log("NODE_ENV:", import.meta.env.MODE);
console.log("API Base URL:", import.meta.env.VITE_API_BASE_URL);

// Not Found and Not Authorized components
const NotAuthorizedComponent = () => (
  <div>
    <h1>Not Authorized</h1>
    <p>You do not have permission to view this page.</p>
  </div>
);

// Create the QueryClient instance
const queryClient = new QueryClient();

function App() {
  const [onboardingData, setOnboardingData] = useState([]);
  const navigate = useNavigate();

  // Redirect if assessment_id is in URL
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const assessmentId = urlParams.get('assessment_id');

    if (assessmentId) {
      localStorage.setItem('assessment_id', assessmentId);
      navigate('/signin');
    }
  }, [navigate]);

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <FilterProvider>
          <SEOProvider> {/* Wrap your app with the SEOProvider */}
          <div className="App">
            <Suspense fallback={<div>Loading layout...</div>}>
              <RoutesConfig
                onboardingData={onboardingData}
                setOnboardingData={setOnboardingData}
              />
            </Suspense>
          </div>
          </SEOProvider>
        </FilterProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
